import { Zlib, Unzlib, strFromU8, strToU8 } from 'fflate';
var Compressor = (function () {
    function Compressor() {
        this.reset();
    }
    Compressor.prototype.reset = function () {
        this.compressor = null;
        this.decompressor = null;
    };
    Compressor.prototype.compress = function (data) {
        if (!this.compressor) {
            this.compressor = new Zlib();
        }
        var result;
        this.compressor.ondata = function (data) {
            result = data;
        };
        this.compressor.push(strToU8(data));
        return result;
    };
    Compressor.prototype.decompress = function (data) {
        if (!this.decompressor) {
            this.decompressor = new Unzlib();
        }
        var result;
        this.decompressor.ondata = function (data) {
            result = data;
        };
        try {
            this.decompressor.push(data);
        }
        catch (error) {
            throw new Error("Decompression error: " + error.message + ", length: " + data.length + ", data: [" + data.toString() + "]");
        }
        return strFromU8(result);
    };
    return Compressor;
}());
export { Compressor };
//# sourceMappingURL=Compressor.js.map